module.exports = "<div class=\"container-fluid fixed-top\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12 px-0\">\r\n      <a routerLink=\"/\">\r\n        <img class=\"pull-right\" src=\"/assets/img/logo.png\" alt=\"\">\r\n      </a>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = ./src/app/header/header.component.html
// module chunks = main